(function( $ ) {
    $.fn.getKVKData = function (kvk, callback) {

    }
});